var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 2.66683C5.05452 2.66683 2.66671 5.05464 2.66671 8.00016C2.66671 10.9457 5.05452 13.3335 8.00004 13.3335C10.9456 13.3335 13.3334 10.9457 13.3334 8.00016C13.3334 5.05464 10.9456 2.66683 8.00004 2.66683ZM1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016Z",
    fill: "#FF754C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93946 10.6465C10.1347 10.8417 10.4512 10.8417 10.6465 10.6465C10.8417 10.4512 10.8417 10.1347 10.6465 9.93946L8.70703 7.99999L10.6465 6.06054C10.8417 5.8653 10.8417 5.54875 10.6465 5.35351C10.4512 5.15827 10.1347 5.15827 9.93946 5.35351L8.00001 7.29297L6.06054 5.35351C5.8653 5.15827 5.54875 5.15827 5.35351 5.35351C5.15827 5.54875 5.15827 5.8653 5.35351 6.06054L7.29297 7.99999L5.35351 9.93944C5.15827 10.1347 5.15827 10.4512 5.35351 10.6465C5.54875 10.8417 5.8653 10.8417 6.06054 10.6465L8.00001 8.70704L9.93946 10.6465Z",
    fill: "#FF754C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.ed3a1c98940ec9388e1077a5c89b9f89.svg";
export { ForwardRef as ReactComponent };